import React from 'react';
import WarehouseCard from './WarehouseCard';
import './WarehouseGrid.css';

export default function WarehouseGrid({ warehouses, onEdit, onWarehouseClick }) {
  if (!warehouses || warehouses.length === 0) {
    return <div className="warehouse-grid-empty">No warehouses found.</div>;
  }

  return (
    <div className="warehouse-grid">
      {warehouses.map(warehouse => (
        <div key={warehouse.id} onClick={() => onWarehouseClick && onWarehouseClick(warehouse)} style={{ cursor: 'pointer' }}>
          <WarehouseCard warehouse={warehouse} onEdit={onEdit} />
        </div>
      ))}
    </div>
  );
}
